import React, { ReactNode, memo } from 'react';
import StickyBox from 'react-sticky-box';
import cx from 'clsx';

import style from './index.module.scss';

type StickySideProps = {
  className?: string;
  children?: ReactNode;
  offsetTop?: number;
  offsetBottom?: number;
};

export const StickySide = memo(
  ({ className, children, offsetTop = 0, offsetBottom = 24 }: StickySideProps) => {
    return (
      <StickyBox
        className={cx(style.stickySide, className)}
        offsetTop={offsetTop}
        offsetBottom={offsetBottom}>
        {children}
      </StickyBox>
    );
  },
);
